import { GamepadCircleLeftIcon } from './GamepadCircleLeftIcon';

/**
 * author: Haley Halcyon
 * id AE90913A-5172-4699-98FC-7B935C753E1E
 * name gamepad-circle-left
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-circle-left.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerCircleLeftIcon = GamepadCircleLeftIcon;
export default ControllerCircleLeftIcon